import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-600 dark:text-gray-400" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_4 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col space-y-1"
}
const _hoisted_7 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "flex items-center space-x-2 text-xs" }
const _hoisted_10 = { class: "text-red-600 dark:text-red-400" }
const _hoisted_11 = { class: "text-green-600 dark:text-green-400" }
const _hoisted_12 = {
  key: 1,
  class: "text-xs text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col space-y-1"
}
const _hoisted_14 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_15 = { class: "font-medium" }
const _hoisted_16 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_19 = {
  key: 1,
  class: "text-xs text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-gray-900 dark:text-gray-100 font-mono"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_22 = ["title"]

import DataTable from '../../../components/shared/DataTable/index.vue'
import type { AuditLog } from '../../../types/audit-logs'
import { auditLogsService } from '../../../services/audit/auditLogsService'

interface Props {
  auditLogs: AuditLog[]
  loading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditLogsTable',
  props: {
    auditLogs: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

// Table configuration
const tableConfig = {
  enableSearch: true,
  enableSort: true,
  enableFilter: true,
  enablePagination: true,
  itemsPerPage: 20,
  searchPlaceholder: 'Search audit logs...',
  emptyMessage: 'No audit logs found',
  defaultSort: {
    field: 'timestamp',
    order: 'desc' as const
  }
}

// Table columns configuration
const columns = [
  {
    field: 'timestamp',
    label: 'Timestamp',
    sortable: true,
    type: 'date' as const,
    class: 'w-48'
  },
  {
    field: 'method',
    label: 'Method',
    sortable: true,
    class: 'w-20'
  },
  {
    field: 'resource',
    label: 'Resource',
    sortable: true,
    class: 'w-40'
  },
  {
    field: 'userId',
    label: 'User',
    sortable: true,
    class: 'w-32'
  },
  {
    field: 'change',
    label: 'Change',
    sortable: false,
    class: 'w-64'
  },
  {
    field: 'url',
    label: 'URL',
    sortable: false,
    class: 'w-64'
  },
  {
    field: 'metadata',
    label: 'Metadata',
    sortable: false,
    class: 'w-40'
  }
]

// Helper methods using the service
const formatTimestamp = auditLogsService.formatTimestamp
const formatHttpMethod = auditLogsService.formatHttpMethod
const formatChangeValue = auditLogsService.formatChangeValue
const getHttpMethodColor = auditLogsService.getHttpMethodColor

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTable, {
    data: _ctx.auditLogs,
    columns: columns,
    config: tableConfig
  }, {
    timestamp: _withCtx(({ value }) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(formatTimestamp)(value)), 1)
    ]),
    method: _withCtx(({ value }) => [
      _createElementVNode("span", {
        class: _normalizeClass([
          'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium',
          _unref(getHttpMethodColor)(value)
        ])
      }, _toDisplayString(_unref(formatHttpMethod)(value)), 3)
    ]),
    resource: _withCtx(({ value }) => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(value.type), 1),
        _createElementVNode("span", _hoisted_4, " ID: " + _toDisplayString(value.id), 1),
        (value.name)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "text-xs text-gray-500 dark:text-gray-400 truncate",
              title: value.name
            }, _toDisplayString(value.name), 9, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    change: _withCtx(({ value }) => [
      value
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[0] || (_cache[0] = _createTextVNode(" Field: ")),
              _createElementVNode("span", _hoisted_8, _toDisplayString(value.field), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatChangeValue)(value.oldValue)), 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-gray-400" }, "→", -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatChangeValue)(value.newValue)), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, " No changes "))
    ]),
    metadata: _withCtx(({ value }) => [
      value
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, [
              _cache[2] || (_cache[2] = _createTextVNode(" Service: ")),
              _createElementVNode("span", _hoisted_15, _toDisplayString(value.service || 'N/A'), 1)
            ]),
            _createElementVNode("span", _hoisted_16, [
              _cache[3] || (_cache[3] = _createTextVNode(" Env: ")),
              _createElementVNode("span", _hoisted_17, _toDisplayString(value.environment || 'N/A'), 1)
            ]),
            _createElementVNode("span", _hoisted_18, " v" + _toDisplayString(value.version || 'N/A'), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, " No metadata "))
    ]),
    userId: _withCtx(({ value }) => [
      value
        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(value), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_21, " System "))
    ]),
    url: _withCtx(({ value }) => [
      _createElementVNode("span", {
        class: "text-sm text-gray-600 dark:text-gray-400 font-mono truncate",
        title: value
      }, _toDisplayString(value), 9, _hoisted_22)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})